/** Client for Jules AI Help HTTP API. */

import { auth } from '../common/firebase';

const DEFAULT_BASE = process.env.REACT_APP_AI_HELP_URL || '';

export function getAiHelpBaseUrl() {
	return (DEFAULT_BASE || '').replace(/\/$/, '');
}

export function isAiHelpConfigured() {
	return !!getAiHelpBaseUrl();
}

async function getIdToken() {
	const user = auth.currentUser;
	if (!user) {
		throw new Error('Not signed in');
	}
	return user.getIdToken();
}

export async function suggestEvents(payload) {
	const base = getAiHelpBaseUrl();
	if (!base) {
		throw new Error('AI Help URL is not configured (REACT_APP_AI_HELP_URL)');
	}

	const token = await getIdToken();
	const res = await fetch(`${base}/v1/suggest-events`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(payload),
	});

	const data = await res.json().catch(() => ({}));
	if (!res.ok) {
		throw new Error(data.error || `suggest-events failed (${res.status})`);
	}
	return data;
}

/** Fast Ask Jules for scenes: prompt + optional date → colors + message. */
export async function askJules(payload) {
	const base = getAiHelpBaseUrl();
	if (!base) {
		throw new Error('AI Help URL is not configured (REACT_APP_AI_HELP_URL)');
	}

	const token = await getIdToken();
	const res = await fetch(`${base}/v1/ask-jules`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify(payload),
	});

	const data = await res.json().catch(() => ({}));
	if (!res.ok) {
		throw new Error(data.error || `ask-jules failed (${res.status})`);
	}
	return data;
}
